"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStyles = exports.propertyValues = void 0;

var correspondings_1 = require("./correspondings");

var align_1 = require("./properties/align");

var flex_1 = require("./properties/flex");

var grid_1 = require("./properties/grid");

var justify_1 = require("./properties/justify");

var space_1 = require("./properties/space");

var columns = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}'
  },
  properties: 'columns'
};
var order = {
  patterns: {
    first: '-9999',
    last: '9999',
    none: '0',
    number: '{{value}}'
  },
  properties: 'order'
};
exports.propertyValues = {
  alignContent: align_1.alignContent,
  alignItems: align_1.alignItems,
  alignSelf: align_1.alignSelf,
  columnGap: grid_1.columnGap,
  columns: columns,
  flex: flex_1.flex,
  flexDirection: flex_1.flexDirection,
  flexFlow: flex_1.flexFlow,
  flexGrow: flex_1.flexGrow,
  flexShrink: flex_1.flexShrink,
  flexWrap: flex_1.flexWrap,
  gap: grid_1.gap,
  gridAutoFlow: grid_1.gridAutoFlow,
  gridColumn: grid_1.gridColumn,
  gridColumnEnd: grid_1.gridColumnEnd,
  gridColumnStart: grid_1.gridColumnStart,
  gridRow: grid_1.gridRow,
  gridRowEnd: grid_1.gridRowEnd,
  gridRowStart: grid_1.gridRowStart,
  gridTemplateColumns: grid_1.gridTemplateColumns,
  gridTemplateRows: grid_1.gridTemplateRows,
  justifyItems: justify_1.justifyItems,
  justifySelf: justify_1.justifySelf,
  mX: space_1.mX,
  order: order,
  rowGap: grid_1.rowGap,
  sX: space_1.sX,
  sY: space_1.sY,
  col: grid_1.gridColumn,
  colEnd: grid_1.gridColumnEnd,
  cols: grid_1.gridTemplateColumns,
  colStart: grid_1.gridColumnStart,
  content: align_1.alignContent,
  direction: flex_1.flexDirection,
  flow: grid_1.gridAutoFlow,
  g: grid_1.gap,
  grow: flex_1.flexGrow,
  gX: grid_1.columnGap,
  gY: grid_1.rowGap,
  items: align_1.alignItems,
  justify: justify_1.justifyContent,
  row: grid_1.gridRow,
  rowEnd: grid_1.gridRowEnd,
  rows: grid_1.gridTemplateRows,
  rowStart: grid_1.gridRowStart,
  self: align_1.alignSelf,
  shrink: flex_1.flexShrink,
  wrap: flex_1.flexWrap
};

var transformValue = function transformValue(key, value, theme) {
  if (correspondings_1.space[key] && undefined !== theme.spacing[value]) {
    return theme.spacing[value];
  }

  if (correspondings_1.size[key] && undefined !== theme.sizes[value]) {
    return theme.sizes[value];
  }

  if (correspondings_1.color[key] && undefined !== theme.colors[value]) {
    return theme.colors[value];
  }

  return String(value);
};

var createStyles = function createStyles(props) {
  var _a;

  var breakpoints = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints;
  var values;
  var styles = {};
  Object.keys(props).forEach(function (key) {
    if (exports.propertyValues[key]) {
      var value = props[key];

      if (undefined !== value) {
        values = !Array.isArray(value) ? [value] : value;
        var regex = /{{value}}/gi;
        var propertyValue = exports.propertyValues[key];
        var properties = Array.isArray(propertyValue.properties) ? propertyValue.properties : [propertyValue.properties];
        values === null || values === void 0 ? void 0 : values.forEach(function (v, index) {
          if (undefined !== v) {
            var pattern;

            if ('string' === typeof v && propertyValue.patterns[v]) {
              pattern = propertyValue.patterns[v];
            } else if ('string' === typeof v && propertyValue.patterns.string) {
              pattern = propertyValue.patterns.string;
            } else if ('number' === typeof v && propertyValue.patterns.number) {
              pattern = propertyValue.patterns.number;
            } else if ('boolean' === typeof v && propertyValue.patterns.boolean) {
              pattern = propertyValue.patterns.boolean;
            } else if (propertyValue.patterns['*']) {
              pattern = propertyValue.patterns['*'];
            } else if (['inherit', 'initial', 'unset'].includes(v)) {
              pattern = v;
            }

            if (pattern) {
              var tmp = styles;

              if (propertyValue.parent) {
                if (!styles[propertyValue.parent]) {
                  styles[propertyValue.parent] = {};
                }

                tmp = styles[propertyValue.parent];
              }

              if (index > 0 && breakpoints && breakpoints[index]) {
                if (!styles["@media (min-width: ".concat(breakpoints[index], ")")]) {
                  tmp["@media (min-width: ".concat(breakpoints[index], ")")] = {};
                }

                properties.forEach(function (property) {
                  if (pattern) {
                    tmp["@media (min-width: ".concat(breakpoints[index], ")")][property] = pattern.replace(regex, transformValue(key, v, props.theme));
                  }
                });
              } else {
                properties.forEach(function (property) {
                  if (pattern) {
                    tmp[property] = pattern.replace(regex, transformValue(key, v, props.theme));
                  }
                });
              }
            }
          }
        });
      }
    }
  });
  return styles;
};

exports.createStyles = createStyles;